import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import * as React from 'react';
import { Suspense, useState } from 'react';
import { Providers } from './providers';
import { Box, CircularProgress, CssBaseline, GlobalStyles, Link } from '@mui/material';
import { AppBar } from './ui/app-bar/app-bar';
import { CopilotDrawer } from './ui/copilot-drawer';
import { logEvent, useTrackAppointment } from '@coverright/shared/analytics';
import startCase from 'lodash/startCase';
import last from 'lodash/last';
import { useLayoutEffect } from 'react';
import { enrollmentApolloClient } from '@coverright/data-access/apollo-clients';
import { useCelebrationAutoTrigger } from '../pages/plans/advanced/ui/celebration';

function RouteFallback() {
  return (
    <Box display={'flex'} justifyContent={'center'} pt={10}>
      <CircularProgress size={32} thickness={3} sx={{ color: '#094451' }} />
    </Box>
  );
}

function AppInner() {
  const location = useLocation();
  const [copilotOpen, setCopilotOpen] = useState(false);
  useTrackAppointment(enrollmentApolloClient);
  const celebrationNode = useCelebrationAutoTrigger();

  useLayoutEffect(() => {
    if (location.pathname) {
      const pageName = startCase(last(location.pathname.split('/')));
      logEvent('page_view', { page_title: pageName });
    }
  }, [location.pathname]);

  return (
    <>
      <CssBaseline />
      {/* Offsets page content below the fixed AppBar (height: 57, see ./ui/app-bar/app-bar.tsx) */}
      <GlobalStyles styles={{ body: { paddingTop: 57 } }} />
      <AppBar onOpenCopilot={() => setCopilotOpen(true)} />
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
      <CopilotDrawer open={copilotOpen} onClose={() => setCopilotOpen(false)} />
      <ScrollRestoration />
      <Box p={2}>
        <Link target={'_blank'} href={'https://coverright.com/privacy-policy/'} fontWeight={500} variant={'body2'}>Privacy policy</Link>
      </Box>
      {celebrationNode}
    </>
  );
}

export function App() {
  return (
    <Providers>
      <AppInner />
    </Providers>
  );
}

export default App;

